import Form from "./components/form";

function App() {
  return (
    <div className="App">
      <Form />
    </div>
  );
}

export default App;